import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash-es';
import { TimesheetBreakdownRuleService } from '../services/timesheet-breakdown-rule.service';
import { PayCategory } from '../shared/models/pay-category';
import { Position } from '../shared/models/position';
import { IRosterCode } from '../shared/models/roster-code';
import { TimesheetBreakdownRule } from '../shared/models/timesheet-breakdown-rule';


@Component({
  selector: 'pps-position-dropdown',
  template: `
    <i *ngIf="updating" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
    <select *ngIf="!updating" [compareWith]="compare" [(ngModel)]="selectedPosition" (change)="onChange($event, selectedPosition)">
      <option *ngFor="let pos of positions" [ngValue]="pos">{{pos.title}}</option>
    </select>
  `,
  styles: [
  ],
})
export class PositionDropdownComponent implements AgRendererComponent {
  private params: any;
  updating: boolean = false;
  positions: Position[] = [];
  selectedPosition: Position;

  constructor() { }

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    let parent = params.context.componentParent;
    
    this.positions = parent.positions;

    this.selectedPosition = params.data.position;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  onChange(evt, position){
    let parent = this.params.context.componentParent;
    let ruleId = this.params.data.id;
    let foundIndex = parent.rules.findIndex(x => x.id === ruleId);
    if (foundIndex === -1){
      console.log("Something wrong");
      return;
    }

    let selectedRule = parent.rules[foundIndex];
    let oldPositionId = this.params.data.position?.id;
    if (position.id !== oldPositionId){
      let rule = _.cloneDeep(selectedRule);
      rule.position = _.cloneDeep(position);
      this.updating = true;
      parent.updateRule(rule, "position", null, null, null, () => this.updating = false);
    }
  }

  compare(a, b){
    return a&&b ? a.id === b.id : false;
  }
}